import React, { ReactNode } from "react";
import "./LevelBlocks.scss";
import { useTranslation } from "react-i18next";

interface IProps {
    children: ReactNode | ReactNode[];
}

export function LevelBlocks({ children }: IProps) {
    const { t } = useTranslation();
    return (
        <div className="level-blocks-wrapper">
            {children}
            <div className="level-blocks-background">
                <svg xmlns="http://www.w3.org/2000/svg" width="841" height="468.661" viewBox="0 0 841 468.661">
                    <defs>
                        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                            <stop offset="0.003" stopColor="#58bdee"/>
                            <stop offset="0.427" stopColor="#29abe2"/>
                            <stop offset="1" stopColor="#226a8f"/>
                        </linearGradient>
                    </defs>
                    <path id="Path_81" data-name="Path 81" d="M940,1162.221H400l-8.91,20.193H208.91L200,1162.221H140a20,20,0,0,0-20,20v416.926a20,20,0,0,0,20,20H940a20,20,0,0,0,20-20V1182.221A20,20,0,0,0,940,1162.221Z" transform="translate(-119.5 -1150.986)" stroke="#33dee2" strokeMiterlimit="10" strokeWidth="1" fill="url(#linear-gradient)"/>
                    <g id="Title" transform="translate(133.5 -1.004)">
                        <text id="INPUT" transform="translate(47 19.004)" fill="#fff" fontSize="18" fontFamily="FranklinGothicATF-Medium, Franklin Gothic ATF" fontWeight="500" letterSpacing="0.05em"><tspan x="-40.446" y="0">{t('game.input').toUpperCase()}</tspan></text>
                    </g>
                </svg>
            </div>
        </div>
    )
}
